import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import "../../Sass/Common.scss";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
          fontSize: "18px !important",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
  },
  reUrgencyIcon: {
    "&>div": {
      background: "rgba(90, 104, 114, 0.1)",
      border: "2px solid rgba(90, 104, 114, 0.7)",
      borderRadius: "68px",
      padding: "20px",
    },
    "&>svg": {
      color: "rgba(90, 104, 114, 0.1)",
    },
  },
}));

const PRNSeleactionDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    onSubmit,
    createRepeatOrderData,
    updateRepeatOrderData,
    singleRepeatOrder,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Typography variant="h4" medium>
                {title}
              </Typography>
            </Box>
          </DialogContent>
        </Box>
        <DialogActions className={classes.dialogActionBtn}>
          <Button
            variant="contained"
            type="submit"
            disabled={
              createRepeatOrderData?.loading ||
              updateRepeatOrderData?.loading ||
              singleRepeatOrder.loading
            }
            startIcon={
              (createRepeatOrderData?.loading ||
                updateRepeatOrderData?.loading) && (
                <CircularProgress color="white" size="20px" />
              )
            }
            onClick={() => onSubmit()}
          >
            Yes
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PRNSeleactionDialog;
